import React, { useCallback } from 'react';
import { ModalType, useModalContext } from '@/context/ModalContext';
import { InvalidCredentialsErrorIcon } from '@/icons/errors';
import BaseModal from '@/components/Modal/BaseModal/BaseModal';
import {
  ModalActions,
  ModalCancelButton,
  ModalContent,
  ModalContentText,
  ModalHeader,
  ModalIcon,
  ModalSubmitButton,
  ModalTitle,
} from '@/components/Modal/Elements';
import CloseButton from '@/components/Modal/Elements/Close/CloseButton';
import { useTranslation } from '@/hooks/useTranslation';
import { AuthTabsValues, useAuthContext } from '@/context/AuthContext';

interface Props {}

const EmailExistErrorModal: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { close } = useModalContext();
  const { tabState } = useAuthContext();
  const [tab, setTab] = tabState;
  const onClose = useCallback(() => {
    close(ModalType.EMAIL_EXIST);
  }, []);
  const onSubmit = useCallback(() => {
    onClose();
    setTab(AuthTabsValues.Login);
  }, []);

  return (
    <BaseModal onClose={onClose}>
      <ModalHeader>
        <CloseButton onClick={onClose} />
      </ModalHeader>
      <ModalIcon>
        <InvalidCredentialsErrorIcon />
      </ModalIcon>
      <ModalContent>
        <ModalTitle>{t('modal.error.email_registered.title')}</ModalTitle>
        <ModalContentText>{t('modal.error.email_registered.sub_title')}</ModalContentText>
      </ModalContent>
      <ModalActions>
        <ModalSubmitButton onClick={onSubmit} text={t('button.login')} />
        <ModalCancelButton onClick={onClose} text={t('button.cancel')} />
      </ModalActions>
    </BaseModal>
  );
};

export default EmailExistErrorModal;
